import * as React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Fabric } from 'office-ui-fabric-react/lib/Fabric';
import { DetailsList, DetailsListLayoutMode, Selection, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { HoverCard } from "office-ui-fabric-react/lib/index";
import { Text, Stack } from 'office-ui-fabric-react/lib';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { MyContext } from '../../../context';

const classNames = mergeStyleSets({
    fileIconHeaderIcon: {
        padding: 0,
        fontSize: '16px'
    },
    fileIconCell: {
        textAlign: 'center',
        selectors: {
            '&:before': {
                content: '.',
                display: 'inline-block',
                verticalAlign: 'middle',
                height: '100%',
                width: '0px',
                visibility: 'hidden'
            }
        }
    },
    fileIconImg: {
        verticalAlign: 'middle',
        maxHeight: '20px',
        maxWidth: '20px'
    },
    controlWrapper: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    exampleToggle: {
        display: 'inline-block',
        marginBottom: '10px',
        marginRight: '30px'
    },
    selectionDetails: {
        marginBottom: '20px'
    }
});
//old storage options to get name for displaying in the table
const oldStorageOptions = [
    { key: "Unknown", text: "Unknown" },
    { key: "Emea", text: "EMEA GRS" },
    { key: "UkSouth", text: "UK South GRS" },
    { key: "Apac", text: "APAC GRS" },
    { key: "Americas", text: "Americas GRS" },
    { key: "Brazil", text: "Brazil GRS" },
    { key: "Canada", text: "Canada GRS" },
    { key: "Japan", text: "Japan GRS" },
    { key: "Switzerland", text: "Switzerland GRS" },
    { key: 'UAENorth', text: "UAE North GRS" },
    { key: "LrsEmea", text: "EMEA LRS" },
    { key: "LrsUkSouth", text: "UK South LRS" },
    { key: "LrsApac", text: "APAC LRS" },
    { key: "LrsAmericas", text: "Americas LRS" },
    { key: "LrsBrazil", text: "Brazil LRS" },
    { key: "LrsCanada", text: "Canada LRS" },
    { key: "LrsJapan", text: "Japan LRS" },
    { key: "LrsSwitzerland", text: "Switzerland LRS" },
    { key: 'LrsUAENorth', text: "UAE North LRS" },
    { key: "GrsSwiss", text: "Swiss GRS" },
    { key: "ZrsSingapore", text: "Singapore Zrs" },
    { key: "ApacSe", text: "APAC Southeast GRS" },
    { key: "S3Storage", text: "S3 Storage" },
    { key: "CustomStorage", text: "Own Storage" }
];
export interface IDetailsListDocumentsExampleState {
    columns: IColumn[];
    selectionDetails: string;
    isModalSelection: boolean;
    isCompactMode: boolean;
}


export default class GroupList extends React.Component<{}, IDetailsListDocumentsExampleState> {
    _selection: Selection;
    _allItems: [];

    constructor(props) {
        super(props);


        let columns: IColumn[] = [
            {
                key: 'column10',
                name: 'Options',
                className: classNames.fileIconCell,
                iconClassName: classNames.fileIconHeaderIcon,
                ariaLabel: 'Column operations for File type, Press to sort on File type',
                isIconOnly: true,
                fieldName: 'name',
                minWidth: 16,
                maxWidth: 16,
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <a style={{ cursor: "pointer" }} onClick={() => { this.props.func(item, 14) }}><Icon iconName={"Settings"} /></a>
                }
            }, {
                key: 'column2',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "name")}</>)}</MyContext.Consumer>,
                fieldName: 'name',
                minWidth: 80,
                maxWidth: 240,
                isResizable: true,
                data: 'number',
                isSorted: true,
                isSortedDescending: false,
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    const expandingCardProps =
                    {
                        onRenderCompactCard: () => {
                            return (
                                <div>
                                    <div className="content-container">
                                        <div className="padding-default-b">
                                            <mgt-person show-name={true} user-id={item.userId} person-card="hover"></mgt-person>
                                        </div>
                                        <ul className="ul-flat">
                                            <li>Name: <a>{item.name}</a> </li>
                                        </ul>
                                        <ul className="ul-flat">
                                            <li>Id: <a>{item.adGroupId}</a> </li>
                                        </ul>

                                    </div>
                                </div>
                            );
                        },
                        onRenderExpandedCard: () => {
                            var nameRecordingRules = "";
                            var nameReplayRules = "";
                            var nameAccessRules = "";
                            var nameAnalyticsRules = "";
                            nameRecordingRules = this.getRuleNameWithProfile(
                                item.recordingRules,
                                this.props.profileData,
                                this.props.ruleData
                            );
                            this.props.ruleData.forEach(function (aRule) {
                                if (aRule.id === item.analytics) {
                                    nameAnalyticsRules = aRule.name;
                                } else if (aRule.id === item.access) {
                                    nameAccessRules = aRule.name;
                                } else if (aRule.id === item.replay) {
                                    nameReplayRules = aRule.name;
                                }
                            });

                            return (
                                <div className="padding-default-b">
                                    <Stack styles={{ paddingLeft: 10 }}>
                                        <Stack.Item styles={{ root: { paddingLeft: "10px" } }}>
                                            <Text>Assigned Rules</Text>
                                            <ul>
                                                <li> Recording Rules: {nameRecordingRules}</li>
                                                <li> Replay Rules: {nameReplayRules}</li>
                                                <li> Access Rules: {nameAccessRules}</li>
                                                <li> Analytics Rules: {nameAnalyticsRules}</li>
                                            </ul>
                                        </Stack.Item>
                                    </Stack>
                                </div>
                            );
                        },
                        renderData: item
                    };

                    return <HoverCard expandingCardProps={expandingCardProps} instantOpenOnClick={true}>
                        <a style={{ cursor: "pointer" }}>{item.name}</a>
                    </HoverCard>;
                }
            }, {
                key: 'column3',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "priority")}</>)}</MyContext.Consumer>,
                fieldName: 'priority',
                minWidth: 90,
                maxWidth: 240,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.priority}</span>;
                }
            },
            {
                key: 'column4',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "license")}</>)}</MyContext.Consumer>,
                fieldName: 'license',
                minWidth: 120,
                maxWidth: 200,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    switch (item.license) {
                        case "0":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "noLicense")}</>)}</MyContext.Consumer>)
                        case "6":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceRecording")}</>)}</MyContext.Consumer>)
                        case "7":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceAnalytics")}</>)}</MyContext.Consumer>)
                        case "1":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecording")}</>)}</MyContext.Consumer>)
                        case "2":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecordingAnalytics")}</>)}</MyContext.Consumer>)
                        case "8":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoice")}</>)}</MyContext.Consumer>)
                        case "9":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoiceAnalytics")}</>)}</MyContext.Consumer>)
                        case "3":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecording")}</>)}</MyContext.Consumer>)
                        case "4":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecordingAnalytics")}</>)}</MyContext.Consumer>)
                        case "5":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "chatRecordingStandalone")}</>)}</MyContext.Consumer>)
                        case "10":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}</>)}</MyContext.Consumer>)
                        case "11":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseSmartBase")}</>)}</MyContext.Consumer>)
                        case "12":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseComplianceBase")}</>)}</MyContext.Consumer>)
                        case "13":
                            return (<MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseEntryVoiceRecording")}</>)}</MyContext.Consumer>)


                    }
                }
            },
            {
                key: 'column12',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "storage")}</>)}</MyContext.Consumer>,
                fieldName: 'storageId',
                minWidth: 120,
                maxWidth: 240,
                isResizable: true,
                data: 'text',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    let displayName = "";
                    //check if old storage is still there only if new storage is not set yet
                    if (item.regionalStorageLocation && !item.storageId) {
                        displayName = oldStorageOptions.map((storage) => {
                            if ((storage.key === item.regionalStorageLocation))
                                return storage.text;
                        });
                    } else if (this.props.storagesList) {  //then show the new storage if available
                        displayName = this.props.storagesList.map((storage) => {
                            if ((storage.id === item.storageId) && (storage.id !== ""))
                                return storage.displayName;
                        });
                    }
                    return displayName;
                }
            },
            {
                key: 'column6',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "recordingRule")}</>)}</MyContext.Consumer>,
                fieldName: 'recordingRules',
                minWidth: 120,
                maxWidth: 240,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    const name = this.getRuleNameWithProfile(
                        item.recordingRules,
                        this.props.profileData,
                        this.props.ruleData
                    );
                    return <span>{name}</span>
                }
            },
            {
                key: 'column7',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "replayRule")}</>)}</MyContext.Consumer>,
                fieldName: 'replay',
                minWidth: 120,
                maxWidth: 240,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    var name = item.replay;
                    this.props.ruleData.forEach(function (aRule) {
                        if (aRule.id === item.replay) {
                            name = aRule.name;
                        };
                    });
                    return <span>{name}</span>;
                }
            },
            {
                key: 'column8',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "acccessRule")}</>)}</MyContext.Consumer>,
                fieldName: 'access',
                minWidth: 120,
                maxWidth: 240,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    var name = item.access;
                    this.props.ruleData.forEach(function (aRule) {
                        if (aRule.id === item.access) {
                            name = aRule.name;
                        };
                    });
                    return <span>{name}</span>;
                }
            },
            {
                key: 'column9',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "analyticsRules")}</>)}</MyContext.Consumer>,
                fieldName: 'analytics',
                minWidth: 120,
                maxWidth: 240,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    var name = item.analytics;
                    this.props.ruleData.forEach(function (aRule) {
                        if (aRule.id === item.analytics) {
                            name = aRule.name;
                        };
                    });
                    return <span>{name}</span>;
                }
            }
        ];
        if (this.props.tenantData?.addOnMsftTeamsVoice) {
            columns.push(
                {
                    key: 'addOnMsftTeamsVoice',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsVoice")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnMsftTeamsVoice',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnMsftTeamsVoice ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData?.addOnMsftTeamsUC) {
            columns.push(
                {
                    key: 'addOnMsftTeamsUC',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnMsftTeamsUC")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnMsftTeamsUC',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnMsftTeamsUC ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnAnalytics) {
            columns.push(
                {
                    key: 'column10',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAnalytics")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnAnalytics',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnAnalytics ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnAIEntry) {
            columns.push(
                {
                    key: 'columnAddOnAIEntry',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnAIEntry")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnAIEntry',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnAIEntry ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnFullChat) {
            columns.push(
                {
                    key: 'column11',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnFullChat")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnFullChat',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnFullChat ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.userRules.addOnCaseManagement) {
            columns.push(
                {
                    key: 'addOnCaseManagement',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCaseManagement")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnCaseManagement',
                    minWidth: 160,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        console.log("item", item);
                        return <span>{item.addOnCaseManagement ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnZoom) {
            columns.push(
                {
                    key: 'column12',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnZoom")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnZoom',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnZoom ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnGenesys) {
            columns.push(
                {
                    key: 'column13',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnGenesys")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnGenesys',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnGenesys ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnRingcentral) {
            columns.push(
                {
                    key: 'column14',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRingcentral")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnRingcentral',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnRingcentral ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnCloud9) {
            columns.push(
                {
                    key: 'addOnCloud9',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCloud9")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnCloud9',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnCloud9 ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnDynamics) {
            columns.push(
                {
                    key: 'column15',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnDynamics")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnDynamics',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnDynamics ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnCompliance) {
            columns.push(
                {
                    key: 'column16',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnCompliance")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnCompliance',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnCompliance ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnQualityManagement) {
            columns.push(
                {
                    key: 'addOnQualityManagement',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnQualityManagement")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnQualityManagement',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnQualityManagement ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnLeapXpert) {
            columns.push(
                {
                    key: 'column17',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnLeapXpert")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnLeapXpert',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnLeapXpert ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnWebex) {
            columns.push(
                {
                    key: 'columnWebex',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnWebex")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnWebex',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnWebex ? "true" : "false"}</span>;
                    }
                });
        }
        if (this.props.tenantData.addOnEmail) {
            columns.push(
                {
                    key: 'column18',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnEmail")}</>)}</MyContext.Consumer>,
                    fieldName: 'addOnEmail',
                    minWidth: 120,
                    maxWidth: 240,
                    isResizable: true,
                    data: 'number',
                    onColumnClick: this._onColumnClick,
                    onRender: (item) => {
                        return <span>{item.addOnEmail ? "true" : "false"}</span>;
                    }
                });
        }

        columns.push(
            {
                key: 'addOnRealTimeTranscript',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "addOnRealTimeTranscript")}</>)}</MyContext.Consumer>,
                fieldName: 'addOnRealTimeTranscript',
                minWidth: 120,
                isResizable: true,
                data: 'number',
                onColumnClick: this._onColumnClick,
                onRender: (item) => {
                    return <span>{item.addOnRealTimeTranscript ? "true" : "false"}</span>;
                }
            });

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    selectionDetails: this._getSelectionDetails()
                });
            }
        });

        this.state = {
            columns: columns,
            selectionDetails: this._getSelectionDetails(),
            isModalSelection: true,
            isCompactMode: true,
            items: this._allItems,
            filter: ""
        };

    }

    // Utility function to get rule name and append [Profile] if from profileData
    getRuleNameWithProfile(ruleId, profileData = [], ruleData = []) {
        let rule = (profileData || []).find(r => r.id === ruleId);
        if (rule) {
            return `${rule.name} [Profile]`;
        }
        rule = (ruleData || []).find(r => r.id === ruleId);
        if (rule) {
            return rule.name;
        }
        return ruleId; // fallback to id if not found
    }

    // Data for CommandBar
    getItems = () => {


        let items = [];

        items.push(
            {
                key: '0',
                name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "noLicense")}</>)}</MyContext.Consumer>,
                iconProps: {
                    iconName: 'ChromeClose'
                },
                onClick: () => { this.props.func(null, 31) }
            }
        );
        if (this.props.tenantData.licenseCompVoice.bought) {
            items.push(
                {
                    key: 'ComplianceVoice',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceRecording")}({this.props.tenantData.licenseCompVoice.used}/{this.props.tenantData.licenseCompVoice.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Microphone'
                    },
                    onClick: () => { this.props.func(null, 19) }
                }
            );
        }
        if (this.props.tenantData.licenseComp.bought) {
            items.push(
                {
                    key: 'ComplianceUC',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecording")}({this.props.tenantData.licenseComp.used}/{this.props.tenantData.licenseComp.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Camera'
                    },
                    onClick: () => { this.props.func(null, 12) }
                }
            );
        }
        if (this.props.tenantData.licenseSmartVoice.bought) {
            items.push(
                {
                    key: 'SmartVoice',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoice")} ({this.props.tenantData.licenseSmartVoice.used}/{this.props.tenantData.licenseSmartVoice.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Microphone'
                    },
                    onClick: () => { this.props.func(null, 21) }
                }
            );
        }
        if (this.props.tenantData.licenseSmart.bought) {
            items.push(
                {
                    key: 'SmartRecording',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecording")}({this.props.tenantData.licenseSmart.used}/{this.props.tenantData.licenseSmart.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Microphone'
                    },
                    onClick: () => { this.props.func(null, 10) }
                }
            );
        }
        if (this.props.tenantData.licenseEntryVoiceRecording != null && this.props.tenantData.licenseEntryVoiceRecording.bought) {
            items.push(
                {
                    key: 'licenseEntryVoiceRecording',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseEntryVoiceRecording")}({this.props.tenantData?.licenseEntryVoiceRecording?.used}/{this.props.tenantData?.licenseEntryVoiceRecording?.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 37) }
                }
            );
        }
        if (this.props.tenantData.licenseSmartBase != null && this.props.tenantData.licenseSmartBase.bought) {
            items.push(
                {
                    key: 'ComplianceVoiceNoRec',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseSmartBase")}({this.props.tenantData?.licenseSmartBase?.used}/{this.props.tenantData?.licenseSmartBase?.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 33) }
                }
            );
        }
        if (this.props.tenantData.licenseComplianceBase != null && this.props.tenantData.licenseComplianceBase.bought) {
            items.push(
                {
                    key: 'ComplianceUCNoRec',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseComplianceBase")}({this.props.tenantData?.licenseComplianceBase?.used}/{this.props.tenantData?.licenseComplianceBase?.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 35) }
                }
            );
        }

        if (this.props.tenantData.licenseAna.bought) {
            items.push(
                {
                    key: 'Analytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "chatRecordingStandalone")} ({this.props.tenantData.licenseAna.used}/{this.props.tenantData.licenseAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'Upload'
                    },
                    onClick: () => { this.props.func(null, 9) }
                }
            );
        }
        if (this.props.tenantData.licenseRecordingInsinghtsAI != null && this.props.tenantData.licenseRecordingInsinghtsAI.bought) {
            items.push(
                {
                    key: 'LicenseRecordingInsinghtsAI',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("tenants", "licenseRecordingInsinghtsAI")}({this.props.tenantData.licenseRecordingInsinghtsAI.used}/{this.props.tenantData.licenseRecordingInsinghtsAI.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 28) }
                }
            );
        }
        if (this.props.tenantData.licenseCompVoiceAna.bought) {
            items.push(
                {
                    key: 'ComplianceVoiceAna',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceVoiceAnalytics")}({this.props.tenantData.licenseCompVoiceAna.used}/{this.props.tenantData.licenseCompVoiceAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 20) }
                }
            );
        }
        if (this.props.tenantData.licenseCompAna.bought) {
            items.push(
                {
                    key: 'ComplianceUCAnalytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "complianceRecordingAnalytics")}({this.props.tenantData.licenseCompAna.used}/{this.props.tenantData.licenseCompAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 13) }
                }
            );
        }

        if (this.props.tenantData.licenseSmartVoiceAna.bought) {
            items.push(
                {
                    key: 'SmartVoiceAnalytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartVoiceAnalytics")}({this.props.tenantData.licenseSmartVoiceAna.used}/{this.props.tenantData.licenseSmartVoiceAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 22) }
                }
            );
        }

        if (this.props.tenantData.licenseSmartAna.bought) {
            items.push(
                {
                    key: 'SmartRecordingAnalytics',
                    name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "smartRecordingAnalytics")}({this.props.tenantData.licenseSmartAna.used}/{this.props.tenantData.licenseSmartAna.bought})</>)}</MyContext.Consumer>,
                    iconProps: {
                        iconName: 'AnalyticsView'
                    },
                    onClick: () => { this.props.func(null, 11) }
                }
            );
        }





        let addButton = {
            key: 'add',
            name: <MyContext.Consumer>{(context) => (<> {context.getTranslation("configuration", "addGroup")}</>)}</MyContext.Consumer>,
            iconProps: { iconName: 'Add' },
            subMenuProps: {
                items: items
            }

        }

        let searchField = {
            key: 'text',
            name: 'text',
            onClick: () => console.log('Rename'),
            onRender: () => { return <div style={{ padding: "4px" }} > <TextField onChange={this._onChangeText} /> </div> },
            iconProps: {
                iconName: 'Edit'
            }
        };

        if (this.props.userRules.ruleAccess != null && this.props.userRules.ruleAccess.confAddUser) {
            return [addButton, searchField];
        } else {
            return [searchField];
        }
    };

    render() {
        const { columns, isModalSelection } = this.state;
        this.ruleData = this.props.ruleData;
        this.userData = this._generateDocuments(this.props.data, this.state.filter);
        return (
            <Fabric>
                <div className={classNames.controlWrapper}>
                </div>
                <CommandBar
                    items={this.getItems()}
                    ariaLabel={'Use left and right arrow keys to navigate between commands'}
                />


                <MarqueeSelection selection={this._selection}>
                    <DetailsList
                        items={this.userData}
                        compact={false}
                        columns={columns}
                        selectionMode={isModalSelection ? SelectionMode.multiple : SelectionMode.none}
                        setKey="set"
                        layoutMode={DetailsListLayoutMode.justified}
                        isHeaderVisible={true}
                        selection={this._selection}
                        selectionPreservedOnEmptyClick={true}
                        onItemInvoked={this._onItemInvoked}
                        enterModalSelectionOnTouch={true}
                        ariaLabelForSelectionColumn="Toggle selection"
                        ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                    />
                </MarqueeSelection>
            </Fabric>
        );
    }

    componentDidUpdate(previousProps: any, previousState: IDetailsListDocumentsExampleState) {
        if (previousState.isModalSelection !== this.state.isModalSelection && !this.state.isModalSelection) {
            this._selection.setAllSelected(false);
        }
    }

    _onChangeCompactMode = (ev: React.MouseEvent<HTMLElement>, checked: boolean): void => {
        this.setState({ isCompactMode: checked });
    };

    _onChangeModalSelection = (ev: React.MouseEvent<HTMLElement>, checked: boolean): void => {
        this.setState({ isModalSelection: checked });
    };

    _onChangeText = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text: string): void => {
        this.userData = this.userData.filter(i => i.name.includes(text) || i.name.toLocaleLowerCase().includes(text));
        this.setState({ filter: text });
    };

    openMultySelect = () => {
        console.log(this._selection.getSelection())
        if (this._selection.getSelection().length > 0) {
            this.props.func(this._selection.getSelection(), 0);
        }
    };

    _getSelectionDetails(): string {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return '';
            case 1:
                return '';
            default:
                return `${selectionCount} Items selected`;
        }
    }

    _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { columns } = this.state;
        const newColumns: IColumn[] = columns.slice();
        const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        newColumns.forEach((newCol: IColumn) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        this.setState({
            columns: newColumns,
        });
    };

    _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey;
        return items.slice(0).sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
    };

    _generateDocuments(DataArr, text) {
        // First filter
        let DataArrFiltered = DataArr.filter(i => i.name == null || (i.name.includes(text) || i.name.toLocaleLowerCase().includes(text)));
        // Then sort
        let newColumns = this.state.columns;
        newColumns.forEach((newCol: IColumn) => {
            if (newCol.isSorted) {
                DataArrFiltered = this._copyAndSort(DataArrFiltered, newCol.fieldName, newCol.isSortedDescending);
            }
        });
        return DataArrFiltered;
    };
}